//Include Both Helper File with needed methods
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  forgotPassword as forgotPasswordApi,
  forgotPasswordNewPass as forgotPasswordNewPassApi,
} from "../../../helpers/ServiceHelpers/backend_helper";

// Forgot Password
export const forgotPassword = createAsyncThunk(
  "post/userForgetPassword",
  async (data: any) => {
    try {
      const response = forgotPasswordApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Forgot Password
export const forgotPasswordNewPass = createAsyncThunk(
  "post/forgotPasswordNewPass",
  async (data: any) => {
    try {
      const response = forgotPasswordNewPassApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
